import { render } from "./menu.vue?vue&type=template&id=d8296f1a&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=d8296f1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d8296f1a"

export default script